import React from "react";
import './styles/employee.css';
import wabes from './styles//images/download.svg';
import employee from './styles/images/employee-img.jpg';
import employee1 from './styles/images/doctor-helping-her-old-patient-stand-up.jpg'
import NewsTicker from "./marequee";
import Hierarchy from "./Hierarchy";
import doc from './styles/images/male-doc.jpg';
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

function Employee() {
const navigate = useNavigate();
    const Editable =()=>{
        var password = prompt("Enter Password","");
        if(password==="samah123"){
            toast.success("Moving To the Next Page...");
            setTimeout(() => {navigate('/quil')},2000);
        }
        else{
            toast.error("Wrong Password!");
        }
       
    }

    const HandleDownload = () => {


        var password = prompt("Enter Password","");
        if(password==="samah123"){
            toast.success("The downloading will start shortly...");
            setTimeout(() => {

                const path = 'employment-application-combined.pdf';
    
                const link = document.createElement('a');
                link.href = path;
                link.download = 'Employment_Application.pdf'; // Set a readable file name
            
                // Append to the body before clicking
                document.body.appendChild(link);
                link.click();
            
                // Use a timeout to ensure it is removed after execution
                setTimeout(() => document.body.removeChild(link), 100);
            },2000);
           
        }
        else{
            toast.error("Wrong Password!");
        }
       
    };
    
    return(
        <>
        <section id="about2" className="about">
                        <div className="wrap"></div>
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">
                                        <h1 className="heading">Join Our <span className="hero-highlight">Team</span>  – <br /> Make a <span className="hero-highlight">Difference</span> Every Day!</h1>
                                        <p className="supporting">
                                        Become a part of a compassionate team dedicated to providing quality care and support.
                                            </p>
                                    </div>
                                </div>
                            </div>
                              <img src={wabes} alt="Waves" id="waves1" />
                        </section>
                        <section id="employee-desc">
                            <div className="container">
                                
                                <div className="row">
                                    <div className="col-lg-7 col-md-6 col-sm-12">
                                        <h1>
                                        Join Our <span className="hero-highlight">Dedicated</span> Team and Make a Difference in <span className="hero-highlight">Care</span>!
                                        </h1>
                                        <p>
                                        At Samah Home Care., we believe that exceptional care starts with dedicated and compassionate professionals. Whether you're an experienced caregiver or beginning your journey in home care, we provide the support, training, and growth opportunities you need to succeed. Our team is built on a foundation of empathy, professionalism, and a commitment to excellence. Join us in making a real difference in the lives of those who need it most—because every act of care matters. Be part of a team that feels like family!
                                        </p>
                                        <button className="nav0cta1">
                                            Learn More
                                        </button>
                                    </div>
                                    <div className="col-lg-5 col-md-6 col-sm-12">
                                        <img src={employee} alt="Employee " id="employee" width={'100%'} />
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="container">
                            <div className="row">
                            <NewsTicker />
                            </div>
                        </div>
                        
                        <section id="careers">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <Hierarchy />
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="careers2">
                            <div className="container">
                                <div className="row mb-5 ">
                                    <div className="col-lg-12 col-md-12 col-sm-12"> 
                                        <h1>
                                            Join Our Team and Make a Difference in Care!
                                        </h1>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <h1 className="mb-4">Download Pdf file: </h1>
                                        <p  className="mb-4">
                                        Need essential documents? Download our comprehensive PDF guide covering job requirements, benefits, and company policies. Stay informed and up-to-date with all the important details you need!
                                        </p>
                                        <button className="nav0cta1" onClick={HandleDownload}>
                                            Download Employee Form
                                        </button>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                                        <img src={doc} alt="one no one no home care samah| Samah Home Care" width={'95%'} className="img-fluid-rounded" />
                                    </div>
                                </div>
                                <div className="row mt-5 mb-5">
                                   
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <img src={employee1} alt="one no one no home care samah| Samah Home Care" width={'95%'} />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                                        <h1 className="mb-4">Online Employee Form</h1>
                                        <p  className="mb-4">
                                        Need essential documents? Download our comprehensive Word guide covering job requirements, benefits, and company policies. Stay informed and up-to-date with all the important details you need!
                                        </p>
                                        <button className="nav0cta1" onClick={Editable}>
                                            Apply Online for Employee
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <footer>
                            <Footer />
                        </footer>
                        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
        </>
    )
}
export default Employee;